
(function () {
  'use strict';

  /* ---- Mobile Nav ---- */
  var hamburger  = document.getElementById('e12-hamburger');
  var mobileMenu = document.getElementById('e12-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---- Smooth scroll for all internal links ---- */
  document.querySelectorAll('.e12-page a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---- Generic form submit handler ---- */
  function handleForm(formId, successId) {
    var form    = document.getElementById(formId);
    var success = document.getElementById(successId);
    if (!form || !success) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      /* Replace this block with your real form submission endpoint */
      var data = Object.fromEntries(new FormData(form));
      console.log('[Engine 12] Form submit:', formId, data);
      /* Simulate async submission */
      form.style.display = 'none';
      success.classList.add('is-visible');
    });
  }

  handleForm('e12-hero-form',    'e12-hero-success');
  handleForm('e12-booking-form', 'e12-booking-success');
  handleForm('e12-popup-form',   'e12-popup-success');

  /* ---- Lead Magnet Popup ---- */
  var popup      = document.getElementById('e12-popup');
  var popupClose = document.getElementById('e12-popup-close');
  var popupShown = false;

  function showPopup() {
    if (!popupShown && popup) {
      popup.classList.add('is-open');
      popupShown = true;
      document.body.style.overflow = 'hidden';
    }
  }

  function closePopup() {
    if (popup) {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* Show after 10 seconds, only if user hasn't seen it in this session */
  if (!sessionStorage.getItem('e12_popup_seen')) {
    setTimeout(function () {
      showPopup();
      sessionStorage.setItem('e12_popup_seen', '1');
    }, 10000);
  }

  if (popupClose) popupClose.addEventListener('click', closePopup);
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });
  }

  /* Hero image parallax */
  var heroBg = document.querySelector('.e12-hero__bg:not(.e12-hero__bg--placeholder)');
  if (heroBg) {
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      heroBg.style.transform = 'scale(1.04) translateY(' + (y * 0.18) + 'px)';
    }, { passive: true });
  }

})();
